module.exports = [{
      plugin: require('/Users/angel/Sites/www-theventagroup-com/theeventagroup/node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/angel/Sites/www-theventagroup-com/theeventagroup/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
